<h2 mat-dialog-title>Composite Cable Calculator</h2>
<mat-dialog-content>
  <form [formGroup]="calculatorForm" class="calculator-form">
    <div class="cable-table">
      <div class="table-header">
        <div class="type-column">Type of Wire</div>
        <div class="diameter-column">Diameter of wire(in)</div>
        <div class="number-column">Number of wires</div>
        <div class="result-column">Cable/Bundle Diameter(in)</div>
      </div>

      <div class="table-body" formArrayName="cables">
        @for (cable of cables.controls; let i = $index; track i) {
          <div class="table-row" [formGroupName]="i">
            <div class="type-column">{{ i + 1 }}</div>
            <div class="diameter-column">
              <input matInput type="number" formControlName="wireDiameter" step="1" />
            </div>
            <div class="number-column">
              <input matInput type="number" formControlName="wireCount" />
            </div>
            <div class="result-column" *ngIf="i === 0">
              <div class="total-diameter">{{ totalDiameter | number: '1.3-3' }}</div>
            </div>
          </div>
        }
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="onClose()">Close</button>
</mat-dialog-actions>
